import React from "react";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import showNotify from "Helpers/Notify";

export default function phoneMask(props) {
  const { inputRef, ...other } = props;
  const numberMask = createNumberMask({
    prefix: "+98",
    suffix: "",
    includeThousandsSeparator: false,
    integerLimit: 10,
  });
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={numberMask}
      onKeyUp={(event) => {
        if (event.target.value.length === 4 && event.target.value[3] == "0") {
          event.target.value = "";
          showNotify({
            text: "Please Check Phone Mask Form",
            customClass: "error",
          });
        }
      }}
      onChange={(event) => {
        if (event.target.value == "") {
        }
      }}
      keepCharPositions={false}
    />
  );
}
